import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './HighPerformingSubtitle.module.scss';

function HighPerformingSubtitle({ selectedMessage }) {
  const { t } = useTranslation('resonance');

  return (
    <div className={scss.subtitle}>
      <span className={scss.stressed}>{t('selectedMessage')}</span>
      <span className={scss.default}>{selectedMessage.message}</span>
    </div>
  );
}

export default HighPerformingSubtitle;
